import axios from "axios";
import { KEY_LOCALSTORAGE } from "../../auth/core/_consts";
import { IQueryBase, OctResponse } from "../../models/OctResponse";
import { APP_CONFIGURATION_KEYS } from "../../utils/Constant";
import { localStorageItem } from "../../utils/LocalStorage";

const BASE_URL =
	localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.[APP_CONFIGURATION_KEYS.API_URL] ||
	process.env.REACT_APP_API_URL;

export const getSignatures = async (
	params: IQueryBase & {
		fromDate: string;
		toDate: string;
	}
) => {
	const { data } = await axios.get<OctResponse<any>>(`${BASE_URL}/`, {
		params,
	});
	return data;
};

export const getSignatureForm = async (params: IQueryBase) => {
	const { data } = await axios.get<OctResponse<any>>(`${BASE_URL}/`, {
		params,
	});
	return data;
};
